export const PHONE_NUMBER_MASK = '000.000.0000';
